export default "__VITE_ASSET__AGe4qtA9__"